import React from "react";

export default function renderIcon({
  width = 34,
  height = 34,
  color = "#f5aa1b",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g id="Group_1001" data-name="Group 1001" transform="translate(-28 -574)">
        <circle
          id="Ellipse_3786"
          data-name="Ellipse 3786"
          cx="17"
          cy="17"
          r="17"
          transform="translate(28 574)"
          fill={color}
        />
        <line
          id="Line_428"
          data-name="Line 428"
          x1="17"
          y1="17"
          transform="translate(36.5 582.5)"
          fill="none"
          stroke="#fff"
          stroke-width="3"
        />
        <line
          id="Line_429"
          data-name="Line 429"
          y1="17"
          x2="17"
          transform="translate(36.5 582.5)"
          fill="none"
          stroke="#fff"
          stroke-width="3"
        />
      </g>
    </svg>
  );
}
